import { useSuspenseQuery } from "@tanstack/react-query";
import { OrderHistoryConfirmedApi } from "@/features/my-order/features/order-history/features/final-copy/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const useGetOrderHistoryConfirmedList = (orderSheetSetId: number) => {
  const identity = useIdentity();

  const params = {
    companyType:
      companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"],
    companyId: identity?.company?.id,
    orderSheetSetId,
  };

  const { data } = useSuspenseQuery({
    queryKey: ["order-history", "confirmed-list", params],
    queryFn: () => OrderHistoryConfirmedApi.getConfirmedList(params),
  });

  return {
    confirmedData: data,
  };
};

export default useGetOrderHistoryConfirmedList;
